export enum DetailRenderType {
  Component,
  Template,
  Dom
}
